import React from "react";
import Slider from "react-slick";

const ImageSlider = ({ images }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 6, infinite: true, autoplay: true, autoplaySpeed: 2000 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 4, infinite: true, autoplay: true, autoplaySpeed: 2000 }
      },
      {
        breakpoint: 550,
        settings: { slidesToShow: 3, infinite: true, autoplay: true, autoplaySpeed: 2000 }
      }
    ]
  };

  return (
    <div className="image-slider-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="slider-image-wrapper">
            <img src={image.src} alt={image.alt} className="slider-image" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
